import { useEffect, useState } from 'react'

interface AssetType {
    name: string
    value: string
    label: string
}

export default function (): [AssetType[], boolean] {
    const [assets, setAssets] = useState([])
    const [loadingAssets, setLoadingAssets] = useState<boolean>(false)
    useEffect(() => {
        const controller = new AbortController()
        const signal = controller.signal

        setLoadingAssets(true)

        fetch(`/services/plugin-liverig/assets/list`, { signal })
            .then(r => r.json())
            .then(assets => {
                setLoadingAssets(false)
                setAssets(assets)
            })
            .catch(e => {
                console.error(e.message, e)
            })

        return () => controller.abort()
    }, [])

    return [assets, loadingAssets]
}
